import { useMemo } from 'react';
import { useSelectedCall } from '@rsos/reduxDataStore/src/features/selectors/callQueueSelector';
import { getMostRecentLocations } from '@rsos/utils/getMostRecentLoc';
import useHasAccessToUniteEventPane from '../../../hooks/useHasAccessToUniteEventPane';
import { Container } from './AdrQueryContainer.styles';
import RequestAdr from './RequestAdr';
import RequestAdrNew from './RequestAdrNew';
import { useHasAccessToRequestAdr } from './selectors/selectors';

const AdrQueryContainer = () => {
  const selectedCall = useSelectedCall();
  const hasAccessToViewButton = useHasAccessToRequestAdr();
  const hasAccessToUniteEventPane = useHasAccessToUniteEventPane();

  const shouldRender = useMemo(() => {
    const mostRecentLoc =
      getMostRecentLocations(selectedCall)?.mostRecentLocation;
    return (
      !!hasAccessToViewButton &&
      mostRecentLoc?.application?.toLowerCase() === 'ios'
    );
  }, [hasAccessToViewButton, selectedCall]);

  if (!shouldRender) {
    return null;
  }

  if (hasAccessToUniteEventPane) return <RequestAdrNew />;
  else
    return (
      <Container>
        <RequestAdr />
      </Container>
    );
};

export default AdrQueryContainer;
